import { QueryKeys, queryClient } from "@/api/core";
import { predictionStatusSchema, type PredictionStatus } from "@/schemas";
import { updateQueryData } from "@/utils/queries";

interface NextPredictionStatusParams extends Partial<PredictionStatus> {}

function updatePredictionStatusCache(
  statusId: string,
  getNextStatusParams: (
    prevStatus: PredictionStatus,
  ) => NextPredictionStatusParams,
): [
  prevStatus: PredictionStatus | undefined,
  nextStatus: PredictionStatus | undefined,
] {
  let nextStatus: PredictionStatus | undefined = undefined;
  const queryKey = QueryKeys.predictions.prediction(statusId);
  let prevStatus = queryClient.getQueryData(queryKey) as
    | PredictionStatus
    | undefined;

  if (!prevStatus) {
    prevStatus = (
      queryClient.getQueryData(QueryKeys.predictions.global) as
        | PredictionStatus[]
        | undefined
    )?.find((entity) => entity.id === statusId);
  }

  if (prevStatus) {
    nextStatus = {
      ...prevStatus,
      ...getNextStatusParams(prevStatus),
    };

    queryClient.setQueryData(queryKey, nextStatus);
    updateQueryData(
      QueryKeys.predictions.global,
      nextStatus,
      predictionStatusSchema,
    );
  }

  return [prevStatus, nextStatus];
}

export { updatePredictionStatusCache };
